import update from 'immutability-helper';
import { AuthActions, AuthActionTypes } from './action';
import { AuthEpicsActions, AuthEpicsActionTypes } from './epics/action';

export interface AuthState {
  isModalOpen: boolean;
  modalState: string;
  prevPage: Array<string>;
  emailFilledOut: boolean;
  error: string;
  password: string;
  showPassword: boolean;
  isPasswordDirty: boolean;
  isPasswordValidLength: boolean;
  containsLettersAndNumbers: boolean;
  containsSpecialChars: boolean;
  isPasswordValid: boolean;
  code: string;
  newPassword: string;
}

const initialAuthState: AuthState = {
  isModalOpen: false,
  modalState: 'wellcome',
  prevPage: [],
  emailFilledOut: false,
  error: null,
  password: null,
  showPassword: false,
  isPasswordDirty: false,
  isPasswordValidLength: false,
  containsLettersAndNumbers: false,
  containsSpecialChars: false,
  isPasswordValid: false,
  code: null,
  newPassword: '',
};

export function authReducer(state = initialAuthState, action: AuthActions | AuthEpicsActions) {
  switch (action.type) {
    case AuthActionTypes.TOGGLE_MODAL:
      return update(state, {
        isModalOpen: { $set: !state.isModalOpen },
        modalState: { $set: 'wellcome' },
      });
    case AuthActionTypes.SET_MODAL_STATE:
      if (action.isPrev) {
        return update(state, {
          prevPage: { $splice: [[state.prevPage.length - 1, 1]] },
          modalState: { $set: action.modalState },
        });
      }
      return update(state, {
        prevPage: { $push: [state.modalState] },
        modalState: { $set: action.modalState },
      });
    case AuthActionTypes.INPUT_PASSWORD:
      const { password } = action;
      const isPasswordDirty = password.length > 0;
      const isPasswordValidLength = password.length >= 8;
      const containsLettersAndNumbers = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[A-Z]).+$/.test(password);
      const containsSpecialChars = /[~#@$%&!*_?^-]/.test(password);
      const isPasswordValid =
        isPasswordDirty && isPasswordValidLength && containsLettersAndNumbers && containsSpecialChars;

      return update(state, {
        password: { $set: action.password },
        isPasswordDirty: { $set: isPasswordDirty },
        isPasswordValidLength: { $set: isPasswordValidLength },
        containsLettersAndNumbers: { $set: containsLettersAndNumbers },
        containsSpecialChars: { $set: containsSpecialChars },
        isPasswordValid: { $set: isPasswordValid },
      });
    case AuthActionTypes.SHOW_PASSWORD:
      return update(state, {
        showPassword: { $set: !state.showPassword },
      });
    case AuthActionTypes.INPUT_CODE:
      return update(state, {
        code: { $set: action.code },
      });
    case AuthEpicsActionTypes.SIGN_UP_SUCCEEDED:
      return update(state, {
        modalState: { $set: 'codeInput' },
      });
    case AuthEpicsActionTypes.VERIFICATION_CODE_SUCCEDED:
      return update(state, {
        modalState: { $set: 'login' },
      });
    case AuthEpicsActionTypes.SIGN_IN_SUCCEEDED:
      return update(state, {
        modalState: { $set: 'successNotification' },
      });
    case AuthEpicsActionTypes.FORGOT_PASSWORD_SUCCEEDED:
      return update(state, {
        modalState: { $set: 'confirmEmail' },
      });
    case AuthActionTypes.REPEAT_NEW_PASSWORD:
      return update(state, {
        newPassword: { $set: action.newPassword },
      });
    case AuthEpicsActionTypes.CONFIRM_PASSWORD_SUCCEEDED:
      return update(state, {
        modalState: { $set: 'login' },
      });
    default:
      return state;
  }
}
